import { useQuery } from '@tanstack/react-query';
import api from '~/api';
import { useUserId } from '~/features/settings/developer/hooks/useUserId';
import { useStoreId } from '~/providers/StoreUserProvider';

export default function useStoreAlerts() {
  const storeId = useStoreId();
  const userId = useUserId();

  return useQuery({
    queryKey: ['store-user-alerts', storeId, userId],
    queryFn: api.store(storeId).userAlerts(userId).list,
    select: (alerts) =>
      // ensure sorting by createdOn desc, then by id desc to consistently have newest alerts first
      alerts
        .sort((a, b) => b.id - a.id)
        .sort(
          (a, b) =>
            new Date(b.createdOn).valueOf() - new Date(a.createdOn).valueOf(),
        ),
  });
}
